<template>
  <UserForm :typeEndPoint="'schoolRoutesNewsShow'" :dataParams="this.$route.params" />
</template>
<script>
import newsForm from '@/components/modules/schoolroutes/news/form'
export default {
  name: 'newsFormEdit',
  components: {
    newsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/news/edit.vue